// @flow
const initialState = {
  email: '',
  password: '',
  rememberMe: false
};
export default initialState;